const	columns = ({ t, locales }) => ([{
	caption: t('common.strings.branch'),
	dataField: 'shopName',
	width: 200,
	Footer: 'Total:'
}, {
	caption: t('common.fields.code'),
	dataField: 'code'
}, {
	caption: t('common.fields.name'),
	dataField: 'name',
	width: 200
}, {
	caption: `${t('statistic_section.strings.group')} 1`,
	dataField: 'group1'
}, {
	caption: `${t('statistic_section.strings.group')} 2`,
	dataField: 'group2'
}, {
	caption: `${t('statistic_section.strings.group')} 3`,
	dataField: 'group3'
}, {
	caption: t('statistic_section.strings.sales_group'),
	dataField: 'salesGroup',
	width: 200
}, {
	caption: t('common.fields.number'),
	dataField: 'number',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.fields.number'),
	dataField: 'number_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.fields.amount'),
	dataField: 'total',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.fields.amount'),
	dataField: 'total_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.weight'),
	dataField: 'weight',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.weight'),
	dataField: 'weight_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.total_cc'),
	dataField: 'creditCustomerTotal',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.total_cc'),
	dataField: 'creditCustomerTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.strings.credit_customer'),
	dataField: 'creditCustomer',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('common.strings.credit_customer'),
	dataField: 'creditCustomer_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.weight_cc'),
	dataField: 'creditCustomerWeight',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.weight_cc'),
	dataField: 'creditCustomerWeight_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.order'),
	dataField: 'order1',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.order'),
	dataField: 'order1_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.return'),
	dataField: 'unsold',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.return'),
	dataField: 'unsold_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: `${t('statistic_section.strings.return')} ${t('common.fields.amount')}`,
	dataField: 'unsoldAmount',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: `${t('statistic_section.strings.return')} ${t('common.fields.amount')}`,
	dataField: 'unsoldAmount_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: `${t('statistic_section.strings.return')} % (${t('common.strings.item')})`,
	dataField: 'unsoldPercent',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: `${t('statistic_section.strings.return')} % (${t('common.strings.item')})`,
	dataField: 'unsoldPercent_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.delivery'),
	dataField: 'deliver',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.delivery'),
	dataField: 'deliver_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.old_stock'),
	dataField: 'oldStock',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.old_stock'),
	dataField: 'oldStock_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.stock_amount'),
	dataField: 'stock',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.stock_amount'),
	dataField: 'stock_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.difference'),
	dataField: 'difference',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.difference'),
	dataField: 'difference_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.difference_amount'),
	dataField: 'differenceAmount',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.difference_amount'),
	dataField: 'differenceAmount_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.date_time'),
	dataField: 'dateTime',
	localFormat: { type: 'date' },
	width: 200
}, {
	caption: t('statistic_section.strings.supporting_documents'),
	dataField: 'supportingDocuments',
	calculateCellValue: ({ billAmount1, billAmount2, billAmount3, billAmount4 }) => billAmount1 + billAmount2 + billAmount3 + billAmount4,
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.supporting_documents'),
	dataField: 'supportingDocumentsCompare',
	compare: true,
	cssClass: 'cell-colored',
	calculateCellValue: ({ billAmount1_compare, billAmount2_compare, billAmount3_compare, billAmount4_compare }) => billAmount1_compare + billAmount2_compare + billAmount3_compare + billAmount4_compare,
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x1',
	dataField: 'billAmount1',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x1',
	dataField: 'billAmount1_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x2',
	dataField: 'billAmount2',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x2',
	dataField: 'billAmount2_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x3',
	dataField: 'billAmount3',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x3',
	dataField: 'billAmount3_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: '>x3',
	dataField: 'billAmount4',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: '>x3',
	dataField: 'billAmount4_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.unique'),
	dataField: 'onlyThis',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.unique'),
	dataField: 'onlyThis_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.first_sale'),
	dataField: 'firstSale',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.first_sale'),
	dataField: 'firstSale_compare',
	compare: true,
	cssClass: 'cell-colored',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.last_sale'),
	dataField: 'lastSale',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.last_sale'),
	dataField: 'lastSale_compare',
	compare: true,
	cssClass: 'cell-colored',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.number_in_cafe'),
	dataField: 'inCafeNumber',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.number_in_cafe'),
	dataField: 'inCafeNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.in_cafe_sales'),
	dataField: 'inCafeTotal',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.in_cafe_sales'),
	dataField: 'inCafeTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	dataField: 'outsideNumber',
	caption: t('statistic_section.strings.outside_number'),
	calculateCellValue: ({ number, inCafeNumber }) => number - inCafeNumber,
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 130
}, {
	dataField: 'outsideNumberCompare',
	caption: t('statistic_section.strings.outside_number'),
	compare: true,
	cssClass: 'cell-colored',
	calculateCellValue: ({ number_compare, inCafeNumber_compare }) => number_compare - inCafeNumber_compare,
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 130
}, {
	caption: t('statistic_section.strings.outside_sales'),
	dataField: 'outsideSales',
	calculateCellValue: ({ total, inCafeTotal }) => total - inCafeTotal,
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 130
}, {
	caption: t('statistic_section.strings.outside_sales'),
	dataField: 'outsideSalesCompare',
	compare: true,
	cssClass: 'cell-colored',
	calculateCellValue: ({ total_compare, inCafeTotal_compare }) => total_compare - inCafeTotal_compare,
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 130
}, {
	caption: t('statistic_section.strings.promotion_number'),
	dataField: 'promotionNumber',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.promotion_number'),
	dataField: 'promotionNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.promotion_sales'),
	dataField: 'promotionTotal',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.promotion_sales'),
	dataField: 'promotionTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.selection_number'),
	dataField: 'breakfastNumber',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 120
}, {
	caption: t('statistic_section.strings.selection_number'),
	dataField: 'breakfastNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 120
}, {
	caption: t('statistic_section.strings.selection_sales'),
	dataField: 'breakfastTotal',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 120
}, {
	caption: t('statistic_section.strings.selection_sales'),
	dataField: 'breakfastTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 120
}, {
	caption: t('statistic_section.strings.discount_number'),
	dataField: 'discountNumber',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.discount_number'),
	dataField: 'discountNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.discount_sales'),
	dataField: 'discountTotal',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.discount_sales'),
	dataField: 'discountTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.gross_profit'),
	dataField: 'grossProfit',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.gross_profit'),
	dataField: 'grossProfit_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.contribution_margin'),
	dataField: 'contributionMargin',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.contribution_margin'),
	dataField: 'contributionMargin_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '%',
	dataField: 'g1Percent',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '%',
	dataField: 'g1Percent_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '+%',
	dataField: 'g1PercentT',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '+%',
	dataField: 'g1PercentT_compare',
	compare: true,
	cssClass: 'cell-colored',
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: 'ABC',
	dataField: 'g1Abc'
}, {
	caption: 'ABC',
	dataField: 'g1Abc_compare',
	compare: true,
	cssClass: 'cell-colored'
}, {
	caption: t('common.fields.number_short'),
	dataField: 'gNumber'
}, {
	caption: t('common.fields.number_short'),
	dataField: 'gNumber_compare',
	compare: true,
	cssClass: 'cell-colored'
}])

export default columns
